<template>
  <div class="magazine">
    <el-row :gutter="isPc == 1 ? 40 : isPc == 2 ? 20 : 20">

      <!-- <el-col
        :span="isPc == 1 ? 6 : isPc == 2 ? 8 : 12"
      >
        <div
          class="magazine-item hand"
          @click="open"
        >
          <img :src="orderImage" class="magazine-img" />
          <div class="magazine-info">
            <h3 class="text-black font20">
              {{ L('《台商》月刊 全年订阅') }}
            </h3>
            <p>
              {{ L("新版上线，欢迎订阅") }}
            </p>
            <button class="hand">
              <svg-icon icon-class="cart"></svg-icon>

              {{ L('前往订阅') }}
            </button>
          </div>
        </div>
      </el-col> -->


      <el-col :span="isPc == 1 ? 6 : isPc == 2 ? 8 : 12" v-for="item in magazineList" :key="item.mgzId+''">
        <div class="magazine-item hand" @click="toDetails(item.mgzId, item.url)">
          <!-- <img :src="item.image" class="magazine-img" /> -->
          <book-3d :image="item.image" />
          <div class="magazine-info">
            <p v-html="item.title" class="magazine-content"></p>
            <!-- <h3 class="text-black font20" v-html="item.content"></h3> -->
            <!-- <p>({{ item.releaseTime }}更新)</p> -->
            <!-- <button class="hand">
              <svg-icon icon-class="cart"></svg-icon>
              前往購買
            </button> -->
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import orderImage from '../../assets/order.png'
import { mapState } from "vuex";
import book3d from './book-3d.vue';
export default {
  components: {
    book3d
  },
  data() {
    return {
      orderImage
    }
  },
  computed: {
    ...mapState(["isPc"]),
  },
  props: {
    magazineList: {
      type: Array,
      default: [],
    },
  },
  methods: {
    fnToBuy(mgzId) {
      this.$router.push({
        path: `/magazine-order/${mgzId}`,
      });
    },
    toDetails(mgzId, url) {
      // if (url) {
      //   window.open(url, "_blank");
      // } else {
      this.$router.push({
        path: `/magazine-details/${mgzId}`,
      });
      // }
    },

    open() {
      this.$router.push({
        path: `/order`,
      });
    }
  },
};
</script>

<style lang="less" scoped>
.magazine {
  .magazine-item {
    margin-bottom: 40px;

    .magazine-img {
      width: 100%;
      height: 362px;
      object-fit: cover;
      border-radius: 8px;
    }

    .magazine-info {
      margin-top: 16px;

      .magazine-content {
        height: 48px;
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 18px;
        color: #2C2C2E;
        line-height: 24px;
        text-align: center;
        font-style: normal;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }

      h3 {
        margin-top: 6px;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #AEAEB2;
        line-height: 19px;
        height: 19px;
        text-align: center;
        font-style: normal;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }

      button {
        padding: 9.1px 41px 11.9px 38.2px;
        border-radius: 20.5px;
        background-color: #e13133;
        font-family: NotoSansCJKTC;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: 2.8px;
        text-align: center;
        color: #fff;
        border: none;
        margin: 6px auto;
        display: block;
        white-space: nowrap;
      }
    }
  }
  .magazine-item:hover {
    .magazine-info {  
      .magazine-content {
        color: #E2291E;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .magazine {
    // margin: 0 15px;

    .magazine-item {
      margin-bottom: 20px;

      .magazine-img {
        width: 100%;
        height: 215px;
        padding-bottom: 10px;
        border-bottom: 2px solid #e13133;
      }

      .magazine-info {
        padding: 0;
        margin-top: 8px;
        .magazine-content{
          height: 28px;
          font-size: 14px;
          line-height: 19px;
        }
        h3 {
          font-size: 14px;
        }

        button {
          cursor: pointer;
          padding: 8px 25.6px 7.1px 25.2px;
          border-radius: 16.5px;
          font-size: 12px;
          letter-spacing: 1.2px;
          margin: 12px auto;
          display: block;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/common/magazine-list.vue